import { Container } from '@mui/material';

import PropTypes from 'prop-types';
import UserRegistrationHeader from './UserRegistrationHeader.js';

function UserRegistrationLayout({ children }) {
  return (
    <Container maxWidth="md">
      <UserRegistrationHeader />
      <>{children}</>
    </Container>
  );
}

UserRegistrationLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserRegistrationLayout;
